import { fetchApi } from '@/config/axiosSetting';
import { addWagesQueryParams } from '@/modules/adjusterReportModules/IncidentParticipants/queries/addWegas/addWegesQuery.type';

export const AddWegasQueryFunction = (params: addWagesQueryParams) =>
  fetchApi.post(
    `property/reports/${params?.id}/accident_users/damaged/adjusting/wages/`,
    params?.data,
    {
      params: {
        damaged_id: params?.damaged_id,
        id: params?.id,
      },
    },
  );
